import { useCallback } from 'react';
import { gql } from '@apollo/client';

import { client } from 'lib/apollo/clients';
import { addErrorToDatadog } from 'lib/datadogError';

export const GET_DISCOUNTED_PRICES = gql`
  query getDiscountedPrices {
    getDiscountedPrices {
      bundleSlug
      discountPercentage
      discountPrice
      expiresAt
      price
      promoCode
      term
    }
  }
`;

const useGetDiscountedPrices = () =>
  useCallback(async () => {
    try {
      const {
        data: { getDiscountedPrices },
      } = await client.query({
        query: GET_DISCOUNTED_PRICES,
        variables: {},
      });

      return getDiscountedPrices;
    } catch (e) {
      addErrorToDatadog(e);
    }
  }, []);

export default useGetDiscountedPrices;
